import {
    createEntityAdapter,
} from '@reduxjs/toolkit';
import { oauth } from '../utils';
import { getGeneralSlice } from './helpers';

const adapter = createEntityAdapter({
    selectId: (object) => object.benefit_id,
    sortComparer: (a, b) => a.display_order - b.display_order,
});

/**
 * The slice/reducers
 */
const slice = getGeneralSlice('companyBenefits', adapter);

export const {
    added,
    deleted,
    loading,
    loaded,
    received,
    updated
} = slice.actions;

const baseUrl = 'supplier-benefit';

/**
 * The actions (thunk)
 */
export const getAll = () => async (dispatch, getState) => {
    dispatch(loading());
    const res = await oauth('GET', baseUrl,  {});
    dispatch(received(res.json?.supplier_benefits));
    return res.json;
};

export const updateItem = (data) => async (dispatch, getState) => {
    console.log('Update', data);
    dispatch(loading());
    const res = await oauth('PUT', baseUrl + '/' + data.supplier_benefit_id, data);
    dispatch(updated({ id: data.benefit_id, changes: data }));
    dispatch(loaded());
    return res.json.supplier_benefit;
};

export const addItem = (data) => async (dispatch, getState) => {
    dispatch(loading());
    const res = await oauth('POST', baseUrl, data);
    dispatch(updated({ id: data.benefit_id, changes: res.json?.supplier_benefit }));
    dispatch(loaded());
    return res.json?.supplier_benefit;
};


export const deleteItem = (data) => async (dispatch, getState) => {
    console.log('delete', data);
    dispatch(loading());
    try {
        await oauth('DELETE', baseUrl + '/' + data.supplier_benefit_id, {});
    } catch (err) {
        console.log('Failed to delete');
        return false;
    }
    console.log('deleted', data);
    dispatch(updated({ id: data.benefit_id, changes: { supplier_benefit_id: '', benefit_description: '' }}));
    dispatch(loaded());
    return true;
};

/**
 * The selectors
 */
export const selectors = adapter.getSelectors();

export default slice.reducer;
